<div class="host-add-quick-message-group">
  <div class="container">
    <div class="v4-layout-form" [formGroup]="form">
      <div class="v4-layout-field">
        <span class="v4-layout-field-label w-20">
          <!-- 名称： -->
          {{ "dialogue_setting.name" | translate }}
        </span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <input
              nz-input
              nzSize="large"
              placeholder="{{ 'placeholder.group_name_required' | translate }}"
              formControlName="name"
            />
          </div>
          <!-- <host-input-with-error
            [showError]="
              checking &&
              (!form.get('name').value || form.get('name').value === '')
            "
            errorText="{{ 'errorText.group_name_required' | translate }}"
          >
    
          </host-input-with-error> -->
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="!isSubAccount">
        <span class="v4-layout-field-label w-20">
          <!-- 可见范围： -->
          {{ "dialogue_setting.visual_range" | translate }}
        </span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-radio-group formControlName="scope">
              <label nz-radio [nzValue]="0">
                <!-- 仅自己 -->
                {{ "dialogue_setting.only_yourself" | translate }}
              </label>
              <label nz-radio [nzValue]="1">
                <!-- 所有账号 -->
                {{ "dialogue_setting.all_account" | translate }}
              </label>
            </nz-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-row items-center justify-between pt-[30px]">
    <div class="ml-auto">
      <button class="mr-3" nz-button type="button" nzSize="large" (click)="cancel()">
        {{ "word.cancel" | translate }}
      </button>
      <button nz-button nzType="primary" nzSize="large" (click)="save()">
        {{ "word.save" | translate }}
      </button>
    </div>
  </div>
</div>
